import Footer from '../components/Footer/Footer';
// import Copilot from '../Copilot/Copilot'; /* eslint-disable */
import { Copilot } from '@iblai/ibl-web-react-common';
import React from 'react';
import { transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      'function randomInt(t,n){return Math.floor(Math.random()*(n-t+1)+t)}function getRandomTimeStamps(t,n,e,a){for(var o=[],r=randomInt(t,n),m=0;m<r;m++){var i=e?new Date(e.getTime()):new Date,d=randomInt(0,367);e||(d=-d),i.setDate(i.getDate()+d),a?(d=randomInt(1,20),o.push({timestamp:i.getTime(),count:d})):o.push(i.getTime())}return o}$(document).ready(function(){$("#github_chart_1").github_graph({data:getRandomTimeStamps(50,600,null,!1),texts:["point","points"],h_days:["Mon","Wed","Fri"],colors:["#E2F1FB","#AAD3F0 ","#93C4E7","#81BBDF","#629ABC"]})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'var MeSeContext=document.getElementById("MeSeStatusCanvas325ba").getContext("2d"),MeSeData={labels:["Javascript","Python","Data Science","Machine Learning"],datasets:[{label:"Points",data:[60,30,70,110,90],backgroundColor:["rgba(113, 160, 204, 0.8)","rgba(81, 205, 108, 0.8)","rgba(104, 81, 205, 0.8)","rgba(81, 205, 198, 0.8)","rgba(204, 195, 113, 0.8)"],borderWidth:2,borderColor:["#71a0cc","#51cd6c","#6851cd","#51cdc6","#ccc371"]}]},MeSeChart=new Chart(MeSeContext,{type:"horizontalBar",data:MeSeData,options:{responsive:!0,maintainAspectRatio:!0,legend:{display:!1},scales:{xAxes:[{ticks:{beginAtZero:!0,min:0,max:120,stepSize:10}}],yAxes:[{barPercentage:.4,borderWidth:10,stacked:!0}]}}});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".billing-option").click(function(){$(".billing-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".bl-p-section").removeClass("active"),$(".bl-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".usage-option").click(function(){$(".usage-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".u-p-section").removeClass("active"),$(".u-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".cpc-tr").click(function(){$(".cpc").show().delay(1e3).fadeOut()}),$(".user-dots").on("click",function(){$(this).toggleClass("active")}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-skills-v7.webflow.io");$(this).attr("href",e)}),$(".submit-prompt").click(function(){$(".human-text").removeClass("hide"),setTimeout(function(){$(".s1")[0].style.display="flex"},1e3),setTimeout(function(){$(".s2")[0].style.display="flex"},2e3)}),$(".skills-option").click(function(){var e=$(this).attr("data-name");$(".skills-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$("html, body").animate({scrollTop:$(".scroll-div[data-name="+e+"]").offset().top-79},1e3)}),$(".item_options").each(function(){$(this).mouseover(function(){var e=$(this).closest("a").attr("href");$(this).closest("a").removeAttr("href"),$(this).closest("a").data("default_url",e)}),$(this).mouseout(function(){$(this).closest("a").data("default_url")&&$(this).closest("a").attr("href",$(this).closest("a").data("default_url"))}),$(this).click(function(){0<$(this).closest(".w-slider-mask").length&&($(this).closest(".w-slider-mask")[0].style.overflow="visible",$(".sl_c").css("z-index","auto"),$(this).closest(".sl_c")[0].style.zIndex="5",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="hidden"}),$(this).closest(".w-slide")[0].style.visibility="visible"),$(".options_div").each(function(e){$(this)[0].style.display="none"}),$(this).find(".options_div").toggle()})}),$(".item_options").click(function(e){e.stopPropagation()}),$(window).click(function(){$(".options_div").each(function(e){$(this)[0].style.display="none",0<$(this).closest(".w-slider-mask").length&&($(this).closest(".sl_c")[0].style.zIndex="auto",$(this).closest(".w-slider-mask")[0].style.overflow="hidden",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="visible"}))})}),$(".mobile_nav_trigger").click(function(){"block"!=$(".mobile_nav")[0].style.display?$(".mobile_nav")[0].style.display="block":$(".mobile_nav")[0].style.display="none"}),$(window).click(function(){$(".mobile_nav")[0].style.display="none"}),$(".mobile_nav").click(function(e){e.stopPropagation()}),$(".mobile_nav_trigger").click(function(e){e.stopPropagation()}),$(".link-options-2").click(function(){var e=$(this).attr("data-name");$(".link-options-2").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(e){$(this).removeClass("active")}),$(".panel[data-name="+e+"]").addClass("active")}),$(".open-chat").click(function(){$(".chatbox").addClass("open"),$(".ch_c").removeClass("hidden")}),$(".minimize").click(function(){$(".chatbox").removeClass("open"),$(".ch_c").addClass("hidden")}),$(".div-block-163").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(".div-block-167").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(window).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"})}),$(".div-block-163").click(function(e){e.stopPropagation()}),$(".div-block-167").click(function(e){e.stopPropagation()}),$(".br_menu").click(function(){$(".br_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".browse_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.browse_panel[data-name="\'+e+\'"]\')[0].style.display="flex"}),$(".f_row").each(function(){$(this).click(function(){$(this).find(".img_v").toggle(),$(this).find(".img_h").toggle(),$(this).next().toggle()})}),$(".f_box .text-field.w-input").each(function(){$(this).keyup(function(){let i=$(this).val();var e=$(this).parent().parent().find(".checkbox-field");$(e).each(function(e){0<=$(this).find(".checkbox-label")[0].innerHTML.toLowerCase().indexOf(i.toLowerCase())?$(this)[0].style.display="block":$(this)[0].style.display="none"})})}),$(".feed-option").click(function(){$(".feed-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".feed_cont").each(function(e){$(this).removeClass("active")}),$(\'.feed_cont[data-name="\'+e+\'"]\').addClass("active"),"messages"==e||"following"==e||"followers"==e?$("body").addClass("messages_active"):$("body").removeClass("messages_active")});var e=window.location.href,e=(console.log(e),e.split("#")[1]);function i(){$(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"),$(".tw_r.new_m_user").each(function(e){$(this).removeClass("active")})}e&&(e=document.querySelector(\'.prof_menu[data-name="\'+e+\'"]\'))&&e.click(),document.getElementById("pink0").oninput=function(){var e=(this.value-this.min)/(this.max-this.min)*100;this.style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+e+"%, #fff "+e+"%, white 100%)"},$("input[type=range]").on("input",function(){var t=$(this).attr("data-index"),l=$(this).val();$("#i"+t).html(l);{let i=0;$(".is-pink0").each(function(e){0<$(this).val()&&(i+=1)}),console.log(i),$("#rs").html(i),3==i?($(".skills_allow")[0].style.display="flex",$(".skills_next0").hide()):($(".skills_allow").hide(),$(".skills_next0").show())}{let e="",i="";0==l?(e="NOT RATED",i="0"):1==l?(e="BEGINNER",i="10px"):2==l?(e="NOVICE",i="60px"):3==l?(e="INTERMEDIATE",i="80px"):4==l?(e="ADVANCED",i="130px"):5==l&&(e="EXPERT",i="160px"),$(".level-text")[t].style.marginLeft=i,$(".level-text")[t].innerHTML=e}l=$(this)[0],t=(l.value-l.min)/(l.max-l.min)*100;$(this)[0].style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+t+"%, #e9eaeb "+t+"%, #e9eaeb 100%)"}),$(".is-pink0").on("touchstart",function(e){}),$(".is-pink0").on("touchend",function(){}),$(".more").click(function(){$(this).hide(),$(".link-block-7").each(function(e){$(this).removeClass("hide")})}),$(".down_arr").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$(".skills_next0.disabled").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills-v2.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$(".c-block").click(function(){$(".cm_popup_div")[0].style.display="flex"}),$(".comment-c").click(function(){$(".cm_popup_div")[0].style.display="none"}),$(".tw-img-trigger").click(function(){$("#tw-img-uploader").trigger("click")}),$(".likes_tab").click(function(){$(".likes_tab").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".profile_text").each(function(e){$(this).removeClass("active")}),$(\'.profile_text[data-name="\'+e+\'"]\').addClass("active"),$(".profile_list").each(function(e){$(this).removeClass("active")}),$(\'.profile_list[data-name="\'+e+\'"]\').addClass("active")}),$(".message_div .tw_r").click(function(){$(".message_div").addClass("mobile_hidden"),$(".chat_div").removeClass("mobile_hidden")}),$(".show_msg_div").click(function(){$(".message_div").removeClass("mobile_hidden"),$(".chat_div").addClass("mobile_hidden")}),$(".follow_tab").click(function(){var e=$(this).attr("data-name");e&&$(\'.feed-option[data-name="\'+e+\'"]\').click()}),$(".follow_tabs_back").click(function(){$(\'.feed-option[data-name="home"]\').click()}),$(".create-group").click(function(){$(".create_group_popup").removeClass("hidden"),$(".new_message_popup").addClass("hidden")}),$(".back_dc").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden")}),$(".cancel_user.c_i").click(function(){i()}),$(".next_form.n_m.next").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden"),$(this).hasClass("disabled")||($(".nm_popup")[0].style.display="none",i())}),$(".new_message").click(function(){$(".nm_popup")[0].style.display="flex"}),$(".tw_r.new_m_user").each(function(e){$(this).click(function(){$(this).toggleClass("active");let i=!1;$(".tw_r.new_m_user").each(function(e){$(this).hasClass("active")&&(i=!0)}),i?($(".n_m.next").removeClass("disabled"),$(".create-group").addClass("hide"),$(".group-users").addClass("show")):($(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"))})}),$(".div-block-181").each(function(e){$(this).click(function(){$(this).find(".div-block-193").toggle()})}),$(".cancel_type_popup").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".cancel_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".add_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".div-block-176").each(function(e){$(this).click(function(){$(".add_content_popup")[0].style.display="none",$(".type_content_popup")[0].style.display="block"})}),$(".content_menu").click(function(){$(".content_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".conent_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.conent_panel[data-name="\'+e+\'"]\')[0].style.display="block","type"==e?$(".add_content_btn").addClass("disabled"):$(".add_content_btn").removeClass("disabled")}),$(".add_content_div").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_content_popup")[0].style.display="block"})}),$(".add_content_btn").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_content").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_popup").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".dc").click(function(){$(".popup_div")[0].style.display="flex",$(".body")[0].style.overflow="hidden",$(".dc_popup")[0].style.display="block"}),$(".cancel_dc").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_dc_div").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_profile_trigger").click(function(){$(".popup_div")[0].style.display="flex",$(".edit_profile_pop")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".cancel_edit_profile").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_edit_prof").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".save_profile_info").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_rating").click(function(){$(".skill_report_popup")[0].style.display="none",$(".rate_skill_popup")[0].style.display="block"}),$(".rate_skill_close").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".cancel_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".confirm_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".skill_box").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".skill_report_popup").toggle()})}),$(".cancel_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".confirm_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".add_skill").click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_skill_popup").toggle()}),$(".confirm_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".cancel_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".dash_nav_item").click(function(){$(".dash_nav_item").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this)[0].innerHTML;$(".panel").each(function(e){$(this)[0].style.display="none"}),$(".panel-"+e.toLowerCase())[0].style.display="flex"}),window.location.hash.substr(1)&&(console.log("fires"),e=window.location.hash.substr(1),$(\'.prof_menu[data-name="\'+e+\'"]\').click());e=new URL(window.location.href).searchParams.get("s");console.log(e),e&&$(\'.prof_menu[data-name="\'+e+\'"]\').trigger("click")}),jQuery.fn.onPositionChanged=function(t,e){null==e&&(e=100);var l,o,s=$(this[0]);return s.length<1||(o=l=null,setInterval(function(){if(null==s||s.length<1)return s;null==l&&(l=s.position()),null==o&&(o=s.offset());var e=s.position(),i=s.offset();l.top==e.top&&l.left==e.left||($(this).trigger("onPositionChanged",{lastPos:l,newPos:e}),"function"==typeof t&&t(l,e),l=s.position()),o.top==i.top&&o.left==i.left||($(this).trigger("onOffsetChanged",{lastOff:o,newOff:i}),"function"==typeof t&&t(o,i),o=s.offset())},e)),s},$(window).on("scroll",function(){$(window).scrollTop()+$(window).height()==$(document).height()?$(".down_arr").hide():$(".down_arr").show()});'
    ),
    isAsync: false,
  },
];

let Controller;

class HomeCopyView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/HomeCopyController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = HomeCopyView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '6596e21ac435cac3c66baae3';
    htmlEl.dataset['wfSite'] = '6596e21ac435cac3c66baad8';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      HomeCopyView.Controller !== HomeCopyView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-skillspro-v3.webflow.css);


            .full.w-bar .right-content {
              display: flex !important;
              flex-direction: column !important;
          }
            @media screen and (min-width: 768px)  and  (max-width: 1090px){
              .div-block-19.cert-grid{
                  grid-template-columns: 1fr;
              }
          }
            .pr-text:after, .pr-text-2:after, .pr-text-3:after, .pr-text-4:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .div-block-346{
            	border-radius:2px;
            }
            .up{
            	white-space: nowrap;
            }
            .text-block-189{
            	margin-bottom:15px;
            }
            .div-block-345.u-p-section, .div-block-345.bl-p-section{
            	padding-top:15px !important;
            }
            .div-block-352.three-dots-menu{
            	height:132px !important;
            }
            .text-block-203{
            	margin-bottom:15px;
            }
            .div-block-357{
            	padding-bottom:12px;
            }
            .form-block.s_skill.r-search.s-r.search-admin{
            	margin-bottom:15px;  
            }
            .div-block-345.bl-p-section{
              	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .div-block-345.d-p-section{
            	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .cpc{
             margin-top:4px !important;
            }
            .user-dots.active{
              background-color: #f7f9fd;
          }
            .d-admin-m{
              height: 36px !important;
              width:152px !important;
          }
            .user-dots.active .d-admin-m{
              display:block; 
          }
            .pm-33{
            	height: 100%;
              display: flex;
              flex-direction: column;
            }
            .pm-272{
            	display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
            .div-block-358{
            	    flex-grow: 1;
                  align-items: start;
            }
            .chat-box.logged-in.jc-start{
            	justify-content:start !important;
            }
          @media only screen and (max-width: 767px) {
              .text-block-167.new-chat-text, .text-block-186,  .text-block-184, .text-block-169 , .text-field-11.ask-input, .all,
              .text-block-192, .rel-answer.open .answer-text, .text-block-189, .textarea-2, .w_i, .create-text, .add-text,
              .rec-h, .text-field.n_text.s-f, .text-block-167.add-resource, .text-block-199, .text-field-12, .text-block-159-train, .text-block-196,
              .text-block-198, .text-block-160, .div-block-340-train .link-options-train, .text-block-165-tr, .text1-tr, .paragraph-tr, .text-block-163-tr, .text-block-86-tr,
              .text-block-86-tr, .instructor-name-train, .instructor-subtitle-train, .instructor-school-train, .text-block-165-train, .text-block-26, 
              .text-block-197, .test-name-3, .text-block-86, .text-block-120, .text-block-86, .question-title-te
              {
                  font-size: 16px !important;
              }
                .instructor-img-train{
                  width: 70px !important;
                  height: 70px !important
              }
              .text-block-191, .text-block-190, .b-link{
                  font-size:14px;
              }
              .image-45{
                  height:18px;
              }
              .content-2.r-hide{
                  padding-bottom:14px !important
              }
              .text-block-16.p, .text-block-124{
                  font-size:13px;
              }
          }
            @media only screen and (max-width: 767px) {
              .sign-in-panel {
              	padding-top:49px;
              }
              .chat-box-sign-in.hidden.open{
              border:none !important;
                height: auto !important;
              }
            }
            .chat-box-sign-in.hidden.open{
            	height:auto;
              padding-bottom:12px;
          	    	    margin-right:0;
              height:100%;
            }
            .or-3-copy{
            	text-align:center;
            }
            .chat-box-sign-in.hidden{
            	    border: 1px solid #dde1e6 !important;
            }
            .chat-1 .content-2{
            	padding-bottom:0 !important;
            }
            .div-block-305:hover {
              background-color: #fff;
          }
            .related_f{
            	display:none;
            }
            .sources_f{
            	display:none;
            }
            .create-div .text-field{
            	width: 100%;
            }
            .add_content_popup .div-block-333{
            	flex: inherit !important;
            }
            .b-link:hover{
            	text-decoration: underline;
            }
            .div-block-347{
            	padding:10px;
              z-index: 2222;
            }
            .b-link{
            	margin-right:6px !important;
            }
            .div-block-262.last{
            	padding-bottom:3px;
            }
            .about_p_popup_resource .about-box-train .faq-question-wrap-2{
              margin-bottom:0;
            }
              .about_p_popup_resource .faq-question-bar-2{
              padding-bottom:0;
            }
            .link-options-train.link-options:hover{
            	border-bottom: 2px solid #6cafe1;
            }
            .about-box-train .text-block-120{
            	    color: #6cafe1;
            }
            .question-title-te, .test-name-3{
             color: #6cafe1;
            }
            .link-options-train{
            	padding-right:0 !important;
            }
            .div-block-340-train{
            	padding-bottom:5px;
            }
            .about-box-train .faq-question-wrap-2{
            	padding-bottom:0;
            }
            .about-vox-train .accordion__title__faq-2{
            	padding:10px !important;
            }
            .about-box-train .div-block-270{
             padding:10px;
            }
            .link-options-train{
            	font-size:14px !important;
            }
            .rec-h{
            	height:40px;
            }
            .outcome-train .image-118{
            	width:16px;
              height:16px;
            }
            .div-block-333{
            	overflow:hidden;
            }
            .outcome-train .skill-div-2{
            	margin-bottom:5px;
              float:left !important;
              clear:both;
            }
            .outcome-train{
            	overflow:hidden;
            }
            .textarea-2{
            	height:250px !important;
              border-radius: 6px;
            }
            .text-block-187-sum:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .chat-1.hidden{
            	display:none;
            }
            .div-block-272{
            	z-index: 222;
            }
            .div-block-329{
            	max-width:350px;
            }
            .chat-box.hidden{
            	flex-grow: 1;
            }
            .chat-box.hidden.h-auto{
            	height: auto !important;
            }
            .rel-answer.open .answer-text{
            	display:block;
            }
            .right-content {
            	    max-height: 100vh;
              overflow: auto;
            }
            .div-block-325.rel{
            	padding-top:14px;
            }
            .h-hide{
            	display:none !important;
            }
            .all .grow-flex{
            	    overflow: auto;
            }
            .rec-div:hover .div-block-332{
              display: block;
          }
            @media screen and (max-width: 767px) {
              .all .grow-flex{
                  max-height: 89vh;
              }
          }
          /* .all .div-block-325.rel{
              position:absolute !important;
          } */
                .div-block-294-open:hover > .hidden-img{
              display:none;
          }
          .div-block-294-open:hover > .hidden-img-rot{
              display:block;
          }
            .rel-answer.open .answer-text{
              height: auto;
              margin-bottom:10px;
          }
            .div-block-294:hover > .image-116{
              display:none;
          }
          .div-block-294:hover > .image-93-rot{
              display:inline-block;
          }
            .rel-row.open .div-block-294{
              display:none;
          }
          .rel-row.open .div-block-294-open{
              display:inline-block;
          }
            .chat-response .form-2{
            	height:40px;
            }
            .chat-box.hidden{
            	height:100% !important;
            }
            .graphs-row{
                	overflow: auto !important;
            }
            .second-input{
            	display:flex;
              align-items:center;
            }
            	@media screen and (max-width: 767px) {
                    .html-embed-2.skill-point.dblock.w-embed.w-script{
                  overflow: auto !important;
                min-width: 600px !important;
              }
                    .reg-show{
                  display: block;
              }
              .form-block-8{
                  padding-top: 0;
              }
                	    .div-block-280{
                  display: none;;
              }
                	    .div-block-272{
                  position: fixed;
                  top: 0;
                  width: 100%;
                  background: #fff;
              }
              .div-block-52{
                  padding-top: 59px;
              }
                	    .chat-2{
                  position: fixed;
                  bottom: 0;
                  width: 100%;
                  background: #fff;
                                margin-bottom: 0;
                  padding-bottom: 14px;
              }
                    .content-2{
                  padding-bottom:100px;
              }
                	    .full.w-bar .chat-box.hidden{
                  border-radius: 0;
                  border: none !important;
              }
                	    .body.chat-active{
                  overflow: hidden;
              }
             .full.w-bar .image-106.right{
                  padding-right:13px;
              } 
              .div-block-325{
                  position: fixed !important;
                  background: #fff;
                  padding-top:12px;
                        margin-left: 0;
                  margin-right: 0;
                        padding-left: 10px;
                  padding-right: 10px;
              }
              .grow-flex{
                  padding-bottom: 66px;
              }
              .full.w-bar .right-content{
                  width: 100% !important;
                        overflow: auto;
                        padding: 0;
              }
              .chat-box{
                  min-height: auto;
                  height:auto;
                  flex-grow: 1;
              }
              .mob-grid{
                  margin-left: auto;
                  margin-right: auto;
              }
              .resize-img{
                  display: none;;
              }
                    .div-block-326{
                  min-width: auto !important;
              }
            }
              @media screen and (max-width: 390px) {
              .div-block-275{
                  margin-right: 8px;
              }
          }
              .with_blink:after{
            	-webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
              color: #21232e;
            }
            	  .no-after:after{
            	content:\"\" !important;
            }
            @keyframes blink {
            0% {
              display: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          /* Apply the animation to an element */
          .blink {
            animation: blink 1s ease-in-out infinite;
          }
          .text-block-187:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .full.w-bar .p_menu {
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
              .chat-box.active.hidden{
            	border-radius: 4px;
            }
          .full.w-bar .right-content{
              display: flex !important;
              flex-direction: column !important;
          }
            .full.w-bar .image-116.right .sm{
              margin-left: auto;
          }
            .full.w-bar .chat-box.hidden{
              display: flex;
          }
            .full.w-bar .p_menu.w_bar{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            .full.w-bar .panels_cont{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            	.full.w-bar .main-content{
              padding-right:380px;
          }
            .full.w-bar .right-content{
              display: block;
          }
          .full.w-bar .right-content{
              width:380px;
          }
            .chat-box{
            	width:auto !important;
              border: 1px solid #dde1e6 !important;
            }
            .about-panels{
              min-height: calc(100vh - 79px - 59px);
          }
          @media screen and (max-width: 767px)  and (min-width: 480px){
            .chatbox.open .open-chat{
              display: none;
            }
            .ch_c{
              margin-bottom: 0;
            }
          }
            .chatbox {
            padding-bottom: env(safe-area-inset-bottom);
                padding-top: env(safe-area-inset-top);
          }
              .about-body{
            	  min-height: calc(100vh - (79px + 58px))
            }
            input[type=range] {
            border-radius: 8px;
            height: 7px;
            outline: none;
            transition: background 450ms ease-in;
            -webkit-appearance: none;
          }
            .fs-rangeslider_track{
            	pointer-events: none;
            }
            .is-pink{
            	    pointer-events: auto;
            }
            .menicon{
            	    -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #4a78b8, #6cafe1);
            }
            .messages_active .al-m.active {
            margin-bottom: 0;
          }
            .tw_r.new_m_user.active .user_tick{
            display: block;
          }
            .body.messages_active .panels{
            padding-bottom: 0;
          }
          .body.messages_active .panels_cont{
          padding-bottom: 0;
          }
            .feed-option.active .tw_t{
            font-weight: 500;
          }
              ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(0,0,0,0.2);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(0,0,0,0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0,.9);
          }
            .add_content_btn.disabled{
            	opacity:0.7;
            }
            .text-block-16{
            overflow-wrap: break-word;
            }
            @media screen and (max-width: 1231px) {
          .results{
            grid-template-columns: 1fr 1fr;
          }
          }
            .inner span {
           	position: relative;
              top:2px;
            }
            .s_box{
                appearance: none;
              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e\");
              background-repeat: no-repeat;
              background-position: right 7px center;
              background-size: 1em;
            }
              @media screen and (max-width: 479px) {
          .results{
            grid-template-columns: 1fr;
          }
          }
          @media screen and (max-width: 1250px) and (min-width: 991px) {
            .slider.w-slider .link-block-7:last-child{
              display: none;
            }
            .div-block-42.sl{
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
            .div-block-78{
            	min-height: calc(100vh - 78px - 70px);
            }
            @media screen and (max-width: 479px) {
           .div-block-78{
            	min-height: calc(100vh - 78px - 101px);
            }
          }
            <style>
            .wday, .month{
            fill: #6d717f;
          }
          .float-right{
            color: #6d717f;
          }
            .more:hover {
                  background-color: #fff;
              background-image: none !important;
          }
            @media screen and (max-width: 479px){
              .dots{
              	    left: calc(50% - 19px);
              }
            }
            	  .chat-box.hidden{
            	height: auto !important;
            }
            @media screen and (max-width: 767px) {
              .chat-box.hidden{
                  height: 100% !important;
              }
                  .full.w-bar .main-content{
                  display:none;
              }
          }
            .chat-2{
            	padding-top: 14px;
            }
            .chat-box.logged-in.hidden{
            	display:none;
            }



              .div-block-325.rel{
                  position:relative
              }
              .three-dots.active .three-dots-menu{
                  display:block !important;
              }
              .three-dots .three-dots-menu{
                  display:none !important;
              }
              .ui-resizable{
                  position:fixed;
                  left: unset!important;
              }
              .scrollbar-thin::-webkit-scrollbar{
                  width: 1px;
              }
              .scrollbar-thin::-webkit-scrollbar-track{
                  border-radius: 20px;
              }
              .scrollbar-thin::-webkit-scrollbar-thumb{
                  width: 5px;
              }



              .copilot-input-box, .gradient-border{
                  border-image-slice: 1;
                  border-image-source: linear-gradient(198deg, rgba(90, 158, 217,1) 12%, rgba(90, 158, 217,0.30858280812324934) 90%);
              }
              .copilot-input-box.is-generating, .gradient-border.is-generating{
                  --angle: 198deg;
                  border-image-slice: 1;
                  border-image-source: linear-gradient(var(--angle), rgba(90, 158, 217,1) 12%, rgba(90, 158, 217,0.30858280812324934) 90%);
                  animation: .8s rotate linear infinite;
              }
              @keyframes rotate {
                  to {
                      --angle: 120deg;
                  }
              }
              @property --angle {
                  syntax: \'<angle>\';
                  initial-value: 0deg;
                  inherits: false;
              }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="full">
              <div className="main-content">
                <div className="div-block-326">
                  <div className="nav">
                    <div className="l-nav">
                      <div className="p_menu">
                        <a className="w-inline-block" href="index.html">
                          <img
                            alt=""
                            className="image"
                            loading="lazy"
                            src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                          />
                        </a>
                        <div className="div-block-231">
                          <a className="dash_nav_item active" href="index.html">
                            Home
                          </a>
                          <a className="dash_nav_item" href="activity.html">
                            Profile
                          </a>
                          <a className="dash_nav_item" href="social.html">
                            Social
                          </a>
                          <a className="dash_nav_item" href="browse.html">
                            Discover
                          </a>
                        </div>
                        <div className="prof_menu hidden" data-name="feed">
                          Feed
                        </div>
                        <div className="nav-right">
                          <div className="div-block-170">
                            <div className="form-block w-form">
                              <form
                                className="form"
                                data-name="Email Form"
                                data-wf-element-id="d40745aa-49d4-dc4d-b7c3-4598f05d720b"
                                data-wf-page-id="6596e21ac435cac3c66baae3"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block">
                                  <img
                                    alt=""
                                    className="image-2"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field n_text w-input"
                                  data-name="Email 8"
                                  id="email-8"
                                  maxLength={256}
                                  name="email-8"
                                  placeholder="Search"
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="div-block-163 pl_s">
                              <img
                                alt=""
                                className="image-3 plus_img"
                                loading="lazy"
                                src="images/plus-2_1plus-2.png"
                              />
                              <img
                                alt=""
                                className="image-3h"
                                loading="lazy"
                                src="images/629f2ca4ae5641d483147dd9_bell.png"
                              />
                              <div className="div-block-164 plus-pop">
                                <div className="div-block-165 nl">
                                  <div className="text-block-105">
                                    ADD CONTENT TO YOUR PROFILE
                                  </div>
                                </div>
                                <div className="box-h">
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">
                                      Article
                                    </div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">Video</div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">
                                      Podcast
                                    </div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">Book</div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">Course</div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">
                                      Program
                                    </div>
                                  </div>
                                  <div className="c-box">
                                    <img
                                      alt=""
                                      className="image-128"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/docs-copy.png"
                                      srcset="images/docs-copy-p-500.png 500w, images/docs-copy.png 512w"
                                    />
                                    <div className="text-block-219">
                                      Assesment
                                    </div>
                                  </div>
                                  <div className="c-box">
                                    <div className="text-block-219">
                                      Create Pathway
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-163">
                              <img
                                alt=""
                                className="image-3"
                                loading="lazy"
                                src="images/bell.png"
                              />
                              <img
                                alt=""
                                className="image-3h"
                                loading="lazy"
                                src="images/629f2ca4ae5641d483147dd9_bell.png"
                              />
                              <div className="div-block-164">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Notifications
                                  </div>
                                </div>
                                <div className="div-block-166">
                                  <div className="text-block-105">
                                    There are no new notifications
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-167">
                              <img
                                alt=""
                                className="image-4"
                                loading="lazy"
                                src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                              />
                              <img
                                alt=""
                                className="image-5"
                                loading="lazy"
                                src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                              />
                              <div className="div-block-164 profile">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Ashley Miller
                                  </div>
                                  <div className="text-block-104 em">
                                    ashley@gmail.com
                                  </div>
                                </div>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="public-profile.html"
                                >
                                  <div className="text-block-106">Profile</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Settings</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Log Out</div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="image-106 hide">
                            <img
                              alt=""
                              className="sm"
                              loading="lazy"
                              src="images/ibl-logo-animated-2.gif"
                            />
                          </div>
                        </div>
                        <div className="mobile_nav_trigger">
                          <div className="menicon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mobile_nav">
                    <div className="mob_nav">
                      <div className="div-block-171">
                        <a className="dash_nav_item active" href="index.html">
                          Home
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="activity.html">
                          Profile
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="social.html">
                          Social
                        </a>
                      </div>
                      <div className="div-block-171 last">
                        <a className="dash_nav_item" href="browse.html">
                          Browse
                        </a>
                      </div>
                    </div>
                    <div className="mob_nav">
                      <div className="form-block mobile w-form">
                        <form
                          className="form"
                          data-name="Email Form"
                          data-wf-element-id="fb7899fa-2d6f-4c5d-ba81-c4611f7cf0b0"
                          data-wf-page-id="6596e21ac435cac3c66baae3"
                          id="email-form"
                          method="get"
                          name="email-form"
                        >
                          <div className="div-block">
                            <img
                              alt=""
                              className="image-2"
                              loading="lazy"
                              src="images/magnifying-glass_1magnifying-glass.png"
                            />
                          </div>
                          <input
                            className="text-field n_text w-input"
                            data-name="Email 7"
                            id="email-7"
                            maxLength={256}
                            name="email-7"
                            placeholder="Search"
                            required=""
                            type="email"
                          />
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                      <div className="div-block-172">
                        <div className="div-block-163">
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            src="images/bell.png"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/629f2ca4ae5641d483147dd9_bell.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Notifications
                              </div>
                            </div>
                            <div className="div-block-166">
                              <div className="text-block-105">
                                There are no new notifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="div-block-163">
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            sizes="100vw"
                            src="images/setting.png"
                            srcset="images/setting-p-500.png 500w, images/setting.png 512w"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/62a1d584bc8cea2ba5c40d38_setting-p-500.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">Settings</div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="https://ibl-skills.webflow.io/profile#pp"
                            >
                              <div className="text-block-106">
                                Profile Settings
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="div-block-167">
                          <img
                            alt=""
                            className="image-4"
                            loading="lazy"
                            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                          />
                          <img
                            alt=""
                            className="image-5"
                            loading="lazy"
                            src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                          />
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="activity.html"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="public-profile.html"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="div-block-317">
                    <div className="welcome_div">
                      <div className="p1">
                        <div className="nav">
                          <div className="nav-cont welcome">
                            <div className="nav-left">
                              <img
                                alt=""
                                className="image welcome"
                                loading="lazy"
                                src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="div-block-78">
                          <div className="div-block-79">
                            <img
                              alt=""
                              className="image-47"
                              loading="lazy"
                              sizes="100vw"
                              src="images/Untitled-1.jpg"
                              srcset="images/Untitled-1-p-500.jpeg 500w, images/Untitled-1.jpg 639w"
                            />
                            <div className="div-block-80">
                              <div className="text-block-60">
                                Welcome to IBL Skills
                              </div>
                              <div className="text-block-61">
                                Enjoy the first high-performance, affordable
                                Skills Learning on AWS Marketplace. It will
                                empower you to build —through selected content
                                and a pedagogical method based on machine
                                learning — the right skills you need to boost
                                your career. 
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="welcome_footer">
                          <div className="dots">
                            <div className="div-block-82 active"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                          </div>
                          <div className="div-block-81">
                            <div
                              className="g_s_btn first_btn"
                              data-w-id="e4983720-d1af-91c4-fab3-e55ae43faf72"
                            >
                              <div>Get Started</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p2">
                        <div className="nav">
                          <div className="nav-cont welcome">
                            <div className="nav-left">
                              <img
                                alt=""
                                className="image welcome"
                                loading="lazy"
                                src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="div-block-78">
                          <div className="div-block-84">
                            <div className="text-block-62">
                              First, add or select the skills you want to
                              develop
                            </div>
                            <div className="form-block welcome w-form">
                              <form
                                className="form welcome_f"
                                data-name="Email Form"
                                data-wf-element-id="b509103d-18d1-2175-335e-7d8db8e29760"
                                data-wf-page-id="6596e21ac435cac3c66baae3"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block">
                                  <img
                                    alt=""
                                    className="image-2"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field w-input"
                                  data-name="Email 6"
                                  id="email-6"
                                  maxLength={256}
                                  name="email-6"
                                  placeholder=""
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="tx_s">18 Selected Skills</div>
                            <div className="div-block-83">
                              <div className="div-block-17">
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Event Management
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Leadership
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Marketing
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Software Development
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Communication
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Software Project Management
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Local Government
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Social Media Marketing
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Social Commentary
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Feminism
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Socieconomics
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Business Comminications
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Communication Skills
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Computer Skills
                                  </div>
                                </div>
                                <div className="div-block-16 welcome">
                                  <div className="text-block-12 welcome">
                                    Editing
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Graphic Design
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Information Architecture
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Research
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Socieconomic development
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Software Testing
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Time Management
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Leadership Dallas
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Instructional Design
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Qualitative Research
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Socioeconomic Impact of Female Education
                                  </div>
                                </div>
                                <div className="div-block-16 welcome selected">
                                  <img
                                    alt=""
                                    className="image-48"
                                    loading="lazy"
                                    src="images/checked_1checked.png"
                                  />
                                  <div className="text-block-12 welcome selected">
                                    Change Management
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="add_skills">
                              <img
                                alt=""
                                className="image-52"
                                loading="lazy"
                                src="images/plus-1_1plus-1.png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="welcome_footer">
                          <div className="dots">
                            <div className="div-block-82"></div>
                            <div className="div-block-82 active"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                          </div>
                          <div className="div-block-81">
                            <div
                              className="g_s_btn-before"
                              data-w-id="9aa50997-bb9c-24ef-8f07-07e00266d9d3"
                            >
                              <div>Previous Step</div>
                            </div>
                            <div className="g_s_btn">
                              <div>Next Step</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p3">
                        <div className="nav">
                          <div className="nav-cont welcome">
                            <div className="nav-left">
                              <img
                                alt=""
                                className="image welcome"
                                loading="lazy"
                                src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="div-block-78">
                          <div className="div-block-84 level_rate">
                            <div className="text-block-62">
                              Now, rate your level
                            </div>
                            <div className="div-block-85">
                              <div className="text-block-63">
                                Event Management
                              </div>
                              <div className="div-block-86">
                                <img
                                  alt=""
                                  className="image-49"
                                  loading="lazy"
                                  src="images/invisible_1invisible.png"
                                />
                                <div>Visible only to you</div>
                              </div>
                              <div className="div-block-88">
                                <div className="div-block-87">
                                  <div className="step_n">1</div>
                                  <div className="step_n">2</div>
                                  <div className="step_n">3</div>
                                  <div className="step_n">4</div>
                                  <div className="step_n">5</div>
                                  <div className="step_n">6</div>
                                  <div className="step_n">7</div>
                                  <div className="step_n">8</div>
                                  <div className="step_n">9</div>
                                  <div className="step_n">10</div>
                                </div>
                                <div className="fs-rangeslider_form w-form">
                                  <form
                                    data-name="Email Form"
                                    data-wf-element-id="47e4e54b-213d-cbb6-63a5-d1d9a2e318e5"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div
                                      className="fs-rangeslider_wrapper"
                                      fs-rangeslider-element="wrapper"
                                      fs-rangeslider-formatdisplay="true"
                                      fs-rangeslider-max={90}
                                      fs-rangeslider-min={0}
                                      fs-rangeslider-step={10}
                                    >
                                      <div
                                        className="fs-rangeslider_track"
                                        fs-rangeslider-element="track"
                                      >
                                        <div
                                          className="fs-rangeslider_handle is-pink"
                                          fs-rangeslider-element="handle"
                                        >
                                          <div className="fs-rangeslider_handle-value"></div>
                                        </div>
                                        <div
                                          className="fs-rangeslider_fill"
                                          fs-rangeslider-element="fill"
                                        ></div>
                                      </div>
                                      <input
                                        className="fs-rangeslider_input w-input"
                                        data-name="From 3"
                                        fs-cmsfilter-field="price"
                                        fs-cmsfilter-range="from"
                                        id="From-3"
                                        maxLength={256}
                                        name="From-3"
                                        placeholder="From"
                                        type="text"
                                      />
                                      <div className="fs-range_values hidden"></div>
                                    </div>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-89">
                                  <div className="text-block-64">Beginner</div>
                                  <div className="text-block-64 mgl">
                                    Expert
                                  </div>
                                </div>
                                <div className="div-block-90">
                                  <img
                                    alt=""
                                    className="image-50"
                                    loading="lazy"
                                    src="images/Screenshot-2022-06-09-at-3.57.09-PM-copy.png"
                                  />
                                  <div className="text-block-65">
                                    Can complete narrow and limited tasks
                                    requiring basic skills with direct
                                    supervision or guidance.
                                  </div>
                                  <div className="div-block-91"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="welcome_footer">
                          <div className="dots">
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82 active"></div>
                            <div className="div-block-82"></div>
                          </div>
                          <div className="div-block-81">
                            <div
                              className="g_s_btn-before"
                              data-w-id="9928e986-ed6f-637d-c317-082c6b14b8b9"
                            >
                              <div>Previous Step</div>
                            </div>
                            <div
                              className="g_s_btn-before skip"
                              data-w-id="3eae9302-eb11-698f-76b4-89e59390c401"
                            >
                              <div>Skip Step</div>
                            </div>
                            <div
                              className="g_s_btn r_n"
                              data-w-id="9928e986-ed6f-637d-c317-082c6b14b8bc"
                            >
                              <div>Next Step</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p4">
                        <div className="nav">
                          <div className="nav-cont welcome">
                            <div className="nav-left">
                              <img
                                alt=""
                                className="image welcome"
                                loading="lazy"
                                src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="div-block-78">
                          <div className="div-block-92">
                            <div className="text-block-66">
                              Start Boosting Your Skills!
                            </div>
                            <div className="text-block-67">
                              Check our content selection or manually add more
                              learning items
                            </div>
                            <img
                              alt=""
                              className="image-51"
                              loading="lazy"
                              src="images/4721728.jpg"
                            />
                          </div>
                        </div>
                        <div className="welcome_footer">
                          <div className="dots">
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82"></div>
                            <div className="div-block-82 active"></div>
                          </div>
                          <div className="div-block-81">
                            <div
                              className="g_s_btn-before"
                              data-w-id="b5575d53-82a4-eb35-2e00-06afccc31678"
                            >
                              <div>Previous Step</div>
                            </div>
                            <div className="g_s_btn r_n">
                              <div>Go</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="panels">
                      <div className="panels_cont w_chat">
                        <div className="panel-home panel">
                          <div className="home_left">
                            <div className="prof_box pp">
                              <div className="div-block-8">
                                <img
                                  alt=""
                                  className="image-7"
                                  loading="lazy"
                                  src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                />
                                <div className="div-block-3">
                                  <div className="text-block">
                                    Ashley Miller
                                  </div>
                                </div>
                              </div>
                              <div className="div-block-161 edit_profile_trigger home">
                                <a
                                  className="w-inline-block"
                                  href="https://ibl-skills-v7.webflow.io/profile#pp"
                                >
                                  <img
                                    alt=""
                                    className="image-24 home"
                                    loading="lazy"
                                    sizes="(max-width: 991px) 14px, 1vw"
                                    src="images/ph.png"
                                    srcset="images/ph-p-500.png 500w, images/ph.png 512w"
                                  />
                                  <img
                                    alt=""
                                    className="ph"
                                    loading="lazy"
                                    sizes="100vw"
                                    src="images/62a1d40ebd16fee404a1d732_pencil.png"
                                    srcset="images/62a1d40ebd16fee404a1d732_pencil-p-500.png 500w, images/62a1d40ebd16fee404a1d732_pencil.png 512w"
                                  />
                                </a>
                              </div>
                            </div>
                            <div className="prof_box">
                              <div className="div-block-15">
                                <div className="text-block sec_title">
                                  Focus Skills
                                </div>
                                <a
                                  className="link-block-5 w-inline-block"
                                  href="https://ibl-skills.webflow.io/profile#skills"
                                >
                                  <img
                                    alt=""
                                    className="image-15"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="_15h"
                                    loading="lazy"
                                    src="images/629f5e8484cc1a56d75188df_plus_1629f5e8484cc1a56d75188df_plus.png"
                                  />
                                </a>
                              </div>
                              <div>
                                <div className="div-block-17 al_l">
                                  <div className="div-block-16">
                                    <div className="text-block-12">
                                      Software Architecture
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-17 al_l">
                                  <div className="div-block-16">
                                    <div className="text-block-12">
                                      Software Testing
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-17 al_l">
                                  <div className="div-block-16">
                                    <div className="text-block-12">
                                      Agile Development
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-17 al_l">
                                  <div className="div-block-16">
                                    <div className="text-block-12">
                                      Product Lifecycle Management
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="div-block-18">
                                <a
                                  className="link-block-4 w-inline-block"
                                  href="https://ibl-skills-v7.webflow.io/profile#skills"
                                >
                                  <div className="text-block-13">
                                    Manage Skills
                                  </div>
                                  <img
                                    alt=""
                                    className="image-15 rc"
                                    loading="lazy"
                                    src="images/chevron_1chevron.png"
                                  />
                                </a>
                                <a
                                  className="link-block-4 start w-inline-block"
                                  href="start.html"
                                >
                                  <div className="text-block-13">
                                    {' '}
                                    Re-Evaluate
                                  </div>
                                  <img
                                    alt=""
                                    className="image-15 rc"
                                    loading="lazy"
                                    src="images/chevron_1chevron.png"
                                  />
                                </a>
                              </div>
                            </div>
                            <div className="prof_box">
                              <div className="text-block sec_title">
                                Credentials
                              </div>
                              <div className="div-block-19 cert-grid">
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-_31d2441e-5337-1e5e-a2f6-60525220f7c5-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-_7db8ace4-edcd-cb3f-153e-ccdcf419d0de-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-_0e49a505-1828-96d3-e6cd-721bcc8fc270-c66baae3"
                                      loading="lazy"
                                      sizes="(max-width: 767px) 70px, (max-width: 991px) 66px, (max-width: 1279px) 70px, (max-width: 1439px) 5vw, 70px"
                                      src="images/b1.png"
                                      srcset="images/b1-p-500.png 500w, images/b1.png 512w"
                                    />
                                    <div className="text-block-75">
                                      Introduction to Javascript
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      6 Jun 2022
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-ead70ae1-3d2d-2792-fe42-b458b8da4946-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-be27fcae-7aa3-6604-2e99-f81c255e8ac8-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-be27fcae-7aa3-6604-2e99-f81c255e8ac9-c66baae3"
                                      loading="lazy"
                                      sizes="(max-width: 767px) 70px, (max-width: 991px) 66px, (max-width: 1279px) 70px, (max-width: 1439px) 5vw, 70px"
                                      src="images/b2.png"
                                      srcset="images/b2-p-500.png 500w, images/b2.png 512w"
                                    />
                                    <div className="text-block-75">
                                      AI and Data Exploration
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      2 Jun 2022
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-_184ac965-dc78-69ad-44f0-1ca38957d706-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-_40def991-5ec8-d848-6286-2c349ffbf3a3-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-_40def991-5ec8-d848-6286-2c349ffbf3a4-c66baae3"
                                      loading="lazy"
                                      sizes="(max-width: 767px) 70px, (max-width: 991px) 66px, (max-width: 1279px) 70px, (max-width: 1439px) 5vw, 70px"
                                      src="images/b3.png"
                                      srcset="images/b3-p-500.png 500w, images/b3.png 512w"
                                    />
                                    <div className="text-block-75">
                                      Java Development
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      29 May 2022
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-_7df92574-ec33-dffc-94fe-d378bb9c5ef6-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-_22cff50d-f530-82b8-7065-485e706b817a-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-_22cff50d-f530-82b8-7065-485e706b817b-c66baae3"
                                      loading="lazy"
                                      src="images/b4_1b4.png"
                                    />
                                    <div className="text-block-75">
                                      Computer Operator
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      22 May 2022
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-_29b43be9-2009-6a22-1a9d-b4df060120ea-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-_0e851c27-1982-4159-4ab5-b2d7006e6947-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-_0e851c27-1982-4159-4ab5-b2d7006e6948-c66baae3"
                                      loading="lazy"
                                      src="images/b5_1b5.png"
                                    />
                                    <div className="text-block-75">
                                      Deep Learning Essentials
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      4 May 2022
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 cr w-inline-block"
                                  href="credential.html"
                                  id="w-node-_586bc118-992a-d4ae-17fd-4b999278603e-c66baae3"
                                >
                                  <div
                                    className="div-block-106"
                                    id="w-node-_825f84d9-71a2-30f5-ed52-a3b5c9c86db8-c66baae3"
                                  >
                                    <img
                                      alt=""
                                      className="image-16"
                                      id="w-node-_825f84d9-71a2-30f5-ed52-a3b5c9c86db9-c66baae3"
                                      loading="lazy"
                                      src="images/b6_1b6.png"
                                    />
                                    <div className="text-block-75">
                                      Machine Learning Basics
                                    </div>
                                    <div className="text-block-76 cr_date">
                                      15 April 2022
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="div-block-18">
                                <a
                                  className="link-block-4 w-inline-block"
                                  href="https://ibl-skills.webflow.io/profile#credentials"
                                >
                                  <div className="text-block-13">
                                    Manage Credentials
                                  </div>
                                  <img
                                    alt=""
                                    className="image-15 rc"
                                    loading="lazy"
                                    src="images/chevron_1chevron.png"
                                  />
                                </a>
                              </div>
                            </div>
                            <div className="prof_box">
                              <div className="text-block sec_title ex_co">
                                Search Content
                              </div>
                              <div className="text-block sec_title fb">
                                Filter By
                              </div>
                              <div className="f_box first">
                                <div className="f_row">
                                  <div>Type</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="1af414b9-3d86-5c40-54f1-579a6e56cb24"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Type"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Courses (6,563)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 4"
                                        id="checkbox-4"
                                        name="checkbox-4"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-4"
                                      >
                                        Pathways (797)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Videos (72)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Assesments (142)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Articles (5)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Books (107)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Documents (45)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Podcasts (32)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Skills</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="e5eb6cbb-3de8-a031-415d-043bb950880b"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Skills"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 5"
                                        id="checkbox-5"
                                        name="checkbox-5"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-5"
                                      >
                                        Computer Programming (1)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Python Libraries (2)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Python Programming (2)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Subject</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="4fc1a383-5641-97f1-b8f0-0f967fbbb4dd"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Subject"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox"
                                        id="checkbox"
                                        name="checkbox"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox"
                                      >
                                        Python (1)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Javascript (2)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Programming (2)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Level</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="10f4a2de-2f80-6af7-cd77-7489219ef4e6"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Level"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 3"
                                        id="checkbox-3"
                                        name="checkbox-3"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-3"
                                      >
                                        Beginner (10)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Intermediate (5)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Advanced (5)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Duration</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="91f223ee-3cd0-f18d-5523-9b7a1698d88c"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Duration"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 3"
                                        id="checkbox-3"
                                        name="checkbox-3"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-3"
                                      >
                                        &lt; 5 Hours
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        &lt; 10 Hours
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        &lt; 1 Week
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        &gt; 1 Week
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Learning Program</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="5d9cfa3f-2065-6bd9-954a-f4999ec638e0"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Learning Program"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 3"
                                        id="checkbox-3"
                                        name="checkbox-3"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-3"
                                      >
                                        Statistics (4)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Programming (6)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Data Structures (3)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Machine Learning (4)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>Organization</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="a5c5bec0-36a2-3a6f-d8ce-0229cd7bd63b"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by Organization"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 3"
                                        id="checkbox-3"
                                        name="checkbox-3"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-3"
                                      >
                                        Coursera (4)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        edX (6)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Pluralshight (3)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Skillshare (4)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="f_box">
                                <div className="f_row">
                                  <div>People</div>
                                  <img
                                    alt=""
                                    className="img_v"
                                    loading="lazy"
                                    src="images/plus_3plus.png"
                                  />
                                  <img
                                    alt=""
                                    className="img_h"
                                    loading="lazy"
                                    src="images/minus-sign_1minus-sign.png"
                                  />
                                </div>
                                <div className="form-block filter w-form">
                                  <form
                                    className="form filter"
                                    data-name="Email Form"
                                    data-wf-element-id="448bcbe9-b5ee-4e23-880d-326741d8d9a3"
                                    data-wf-page-id="6596e21ac435cac3c66baae3"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div className="div-block-9">
                                      <input
                                        className="text-field w-input"
                                        data-name="Email 2"
                                        id="email-2"
                                        maxLength={256}
                                        name="email-2"
                                        placeholder="Search by People"
                                        required=""
                                        type="email"
                                      />
                                      <div className="div-block">
                                        <img
                                          alt=""
                                          className="image-2"
                                          loading="lazy"
                                          src="images/loupe_1loupe.png"
                                        />
                                      </div>
                                    </div>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 3"
                                        id="checkbox-3"
                                        name="checkbox-3"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-3"
                                      >
                                        Alan Byrd (4)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Jayme Rose (6)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Tianna Croft (3)
                                      </span>
                                    </label>
                                    <label className="w-checkbox checkbox-field">
                                      <input
                                        className="w-checkbox-input checkbox"
                                        data-name="Checkbox 2"
                                        id="checkbox-2"
                                        name="checkbox-2"
                                        type="checkbox"
                                      />
                                      <span
                                        className="checkbox-label w-form-label"
                                        htmlfor="checkbox-2"
                                      >
                                        Oscar Don (4)
                                      </span>
                                    </label>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="prof_box grey">
                              <div className="div-block-376">
                                <img
                                  alt=""
                                  className="image-127"
                                  loading="lazy"
                                  src="images/plus-2_1plus-2.png"
                                />
                              </div>
                              <div className="text-block sec_title ex_co amc">
                                Add My Content
                              </div>
                            </div>
                            <div className="prof_box hidden">
                              <div className="text-block sec_title">
                                Monthly Activity
                              </div>
                              <div>
                                <div className="div-block-20">
                                  <div className="div-block-21">
                                    <img
                                      alt=""
                                      className="image-17"
                                      loading="lazy"
                                      src="images/skills_icon_1skills_icon.png"
                                    />
                                  </div>
                                  <div className="text-block-14">
                                    Skills Achieved
                                  </div>
                                  <div className="text-block-15">(25)</div>
                                </div>
                                <div className="div-block-20">
                                  <div className="div-block-21">
                                    <img
                                      alt=""
                                      className="image-17"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/check_2.png"
                                      srcset="images/check_2-p-500.png 500w, images/check_2.png 512w"
                                    />
                                  </div>
                                  <div className="text-block-14">
                                    Course Completions
                                  </div>
                                  <div className="text-block-15">(12)</div>
                                </div>
                                <div className="div-block-20">
                                  <div className="div-block-21">
                                    <img
                                      alt=""
                                      className="image-17"
                                      loading="lazy"
                                      sizes="100vw"
                                      src="images/trophy.png"
                                      srcset="images/trophy-p-500.png 500w, images/trophy.png 512w"
                                    />
                                  </div>
                                  <div className="text-block-14">
                                    Skill Coins Earned
                                  </div>
                                  <div className="text-block-15">(105)</div>
                                </div>
                              </div>
                              <div className="div-block-18">
                                <a
                                  className="link-block-4 w-inline-block"
                                  href="https://ibl-skills.webflow.io/profile#activity"
                                >
                                  <div className="text-block-13">
                                    All Activity
                                  </div>
                                  <img
                                    alt=""
                                    className="image-15 rc"
                                    loading="lazy"
                                    src="images/chevron_1chevron.png"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="home_right">
                            <div className="div-block-33 sp">
                              <div className="div-block-13 l-h h w100 ovh">
                                <div className="div-block-14">
                                  <div className="skm">Engagement</div>
                                </div>
                                <div className="html-embed-2 w-embed w-script">
                                  <link
                                    defer=""
                                    href="https://cdn.jsdelivr.net/gh/sppantg/cont-graph@main/css/github_contribution_graph.css"
                                    media="all"
                                    rel="stylesheet"
                                  />
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html: `
	.af-view .wday, .af-view .month{
  fill: #6d717f !important;
	}
  .af-view .gcont{
  	width: 816px;
    padding-left: 16px;
  }
@media only screen and (max-width: 1269px) {
  .af-view .gcont{
    overflow: auto;
  }
}
 `,
                                    }}
                                  />
                                  <div className="gcont">
                                    <div id="github_chart_1"></div>
                                    <div className="width-full f6 px-0 px-md-5 py-1">
                                      <div
                                        className="float-right color-fg-muted"
                                        title="A summary of pull requests, issues opened, and commits to the default and gh-pages branches."
                                      >
                                        Less
                                        <svg
                                          className="d-inline-block"
                                          height={10}
                                          width={10}
                                        >
                                          <rect
                                            className="ContributionCalendar-day"
                                            data-level={0}
                                            fill="#E2F1FB"
                                            height={10}
                                            rx={2}
                                            ry={2}
                                            width={10}
                                          ></rect>
                                        </svg>
                                        <svg
                                          className="d-inline-block"
                                          height={10}
                                          width={10}
                                        >
                                          <rect
                                            className="ContributionCalendar-day"
                                            data-level={1}
                                            fill="#AAD3F0"
                                            height={10}
                                            rx={2}
                                            ry={2}
                                            width={10}
                                          ></rect>
                                        </svg>
                                        <svg
                                          className="d-inline-block"
                                          height={10}
                                          width={10}
                                        >
                                          <rect
                                            className="ContributionCalendar-day"
                                            data-level={2}
                                            fill="#93C4E7"
                                            height={10}
                                            rx={2}
                                            ry={2}
                                            width={10}
                                          ></rect>
                                        </svg>
                                        <svg
                                          className="d-inline-block"
                                          height={10}
                                          width={10}
                                        >
                                          <rect
                                            className="ContributionCalendar-day"
                                            data-level={3}
                                            fill="#81BBDF"
                                            height={10}
                                            rx={2}
                                            ry={2}
                                            width={10}
                                          ></rect>
                                        </svg>
                                        <svg
                                          className="d-inline-block"
                                          height={10}
                                          width={10}
                                        >
                                          <rect
                                            className="ContributionCalendar-day"
                                            data-level={4}
                                            fill="#629ABC"
                                            height={10}
                                            rx={2}
                                            ry={2}
                                            width={10}
                                          ></rect>
                                        </svg>
                                        More
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-33">
                              <div className="div-block-29 w100">
                                <div className="div-block-12 hidden">
                                  <div className="text-block-21">Skills</div>
                                  <div className="text-block-11">
                                    Manage Skills
                                  </div>
                                </div>
                                <div className="div-block-13 l-h h">
                                  <div className="div-block-14">
                                    <div className="skm">
                                      Skill Leaderboard
                                      <br />
                                    </div>
                                  </div>
                                  <div className="div-block-238">
                                    <div className="html-embed-2 _w-w w-embed">
                                      <style
                                        dangerouslySetInnerHTML={{
                                          __html: `
.af-view .skills-c .sv_img{
  height:158px;
  width:100%;
}
.af-view .skills-c .axisLabel__ac6OU{
margin-left:auto;
margin-right:auto;
}
.af-view .skills-c .a {
color: #6d717f !important;
background: transparent;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-ms-flex-wrap: wrap;
flex-wrap: wrap;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-box-align: end;
-ms-flex-align: end;
align-items: flex-end;
font-size: 12px;
font-size: var(--ps-type-font-size-100);
font-weight: 500;
font-weight: var(--ps-type-font-weight-500);
padding: 16px 32px;
padding: var(--ps-layout-spacing-medium) 32px;
margin-bottom: 16px;
margin-bottom: var(--ps-layout-spacing-medium);
}
.af-view .skills-c .titleContainer__Fwuxu {
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-webkit-box-pack: justify;
-ms-flex-pack: justify;
justify-content: space-between;
font-size: 16px;
font-size: var(--ps-type-font-size-base);
text-align: left;
padding-bottom: 24px;
padding-bottom: var(--ps-layout-spacing-large);
width: 100%;
}
.af-view .skills-c .b {
padding-bottom: 59px;
position: relative;
margin-left: -5%;
width:auto%;
}
.af-view .skills-c .c {
opacity: 65%;
position: absolute;
right: 26px;
top: -8px;
}
.af-view .skills-c .d {
background: #FFFFFF;
opacity: 30%;
height: 1px;
margin-left: auto;
margin-right: 13px;
max-width: 7px;
}
.af-view .skills-c .f {
margin: 0 16px 0 0;
border-right-color: #cecece;
border-right-width: 1px;
border-right-style: solid;
padding-left: 15px;
line-height: 147.5px;
max-height: 151.5px;
}
.af-view .skills-c .f > p {
opacity: 95%;
-webkit-transform: rotate(-90deg);
transform: rotate(-90deg);
width: -webkit-max-content;
width: -moz-max-content;
width: max-content;
text-align: center;
}
.af-view .skills-c .g {
opacity: 65%;
position: absolute;
right: 26px;
bottom: 59px;
}
.af-view .skills-c .i {
width:85%
}
.af-view .skills-c .h {
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-ms-flex-wrap: wrap;
flex-wrap: wrap;
-webkit-box-pack: start;
-ms-flex-pack: start;
justify-content: flex-start;
}
.af-view .skills-c .j {
height: 100%;
position: relative;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
width: 100%;
}
.af-view .skills-c .k {
width: 100%;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-webkit-box-orient: horizontal;
-webkit-box-direction: normal;
-ms-flex-direction: row;
flex-direction: row;
}
.af-view .skills-c .m:first-of-type {
margin-left: 0px;
}
.af-view .skills-c .l dt {
background-color: #d52ace ;
}
.af-view .skills-c .n dt {
height: 3px;
}
.af-view .skills-c .m dt {
position: absolute;
top: 0px;
left: 0px;
width: 100%;
}
.af-view .skills-c .m {
-webkit-box-flex: 1;
-ms-flex-positive: 1;
flex-grow: 1;
-ms-flex-preferred-size: 0;
flex-basis: 0;
font-size: 14px;
font-weight: 400;
text-align: center;
padding-top: 12px;
line-height: 18px;
margin-left: 1px;
overflow: hidden;
position: relative;
color: rgba(255, 255, 255, 0.7);
color: var(--ps-colors-text-icon-low-on-dark);
padding-bottom: 0;
margin-bottom:0;
}
.af-view .skills-c .s {
width: 100%;
position: relative;
height: 175px;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-webkit-box-align: end;
-ms-flex-align: end;
align-items: flex-end;
}
.af-view .skills-c .t {
display: -webkit-box;
display: -ms-flexbox;
display: flex;
height: 237px;
width: 100%;
position: absolute;
bottom: -36px;
left: 0;
}
.af-view .skills-c .u.w.v {
background-color: #d52ace ;
}
.af-view .skills-c .v {
-webkit-box-flex: 1;
-ms-flex-positive: 1;
flex-grow: 1;
opacity: 20%;
width: 100%;
margin-right: 1px;
height: 0;
-webkit-transition: opacity 15000ms ease-in-out;
transition: opacity 15000ms ease-in-out;
}
@keyframes fadeInAnimation {
    0% {
        height: 0;
    }
    100% {
        height: 100%;
    }
}
.af-view .skills-c .v{
          animation: fadeInAnimation ease-in-out 500ms;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
}
.af-view .skills-c .percentileScore__eqaA3 {
position: absolute;
bottom: 0;
left: 0;
-webkit-transform: translate(-50%, -12px);
transform: translate(-50%, -12px);
width: 84px;
text-align: center;
font-size: 14px;
line-height: 14px;
background: transparent;
line-height: 14px;
color: rgba(255, 255, 255, 0.95);
color: var(--ps-colors-text-icon-high-on-dark);
}
.af-view .skills-c .scoreBase__Z1ipd {
position: absolute;
bottom: 0;
left: 0;
min-width: 2px;
min-height: 7px;
max-width: 410px;
max-height: 124px;
border-top: 1px dashed rgba(255, 255, 255, 0.7);
}
.af-view .skills-c .score__IvWkK {
color: #6d717f;
margin: 0px;
position: absolute;
left: -25px;
background: #fff;
top:-11px
/* bottom:0; */
}
@keyframes moveBottom {
    0% {
        bottom: 0;
    }
    100% {
        bottom: 27px;
    }
}
/* .score__IvWkK{
          animation: moveBottom ease-in-out 800ms;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
} */
@keyframes moveWidth {
    0% {
        width: 0;
    }
    10% {
        width: 0;
    }
    100% {
        width: 8.3%;
    }
}
@keyframes moveHeight {
    0% {
        height: 0;
    }
    85% {
        height: 40px;
    }
    100%{
          height: 40px;
    }
}
.skills-c .scoreBase__Z1ipd{
          animation: moveWidth ease-in-out 900ms, moveHeight ease-in-out 900ms;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
}
/* .scoreBase__Z1ipd{
          animation: moveHeight moveWidth ease-in-out 800ms;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
} */
.af-view .skills-c .gravatarUrl__AzQ29 {
background: #fff;
border-radius: 100px;
position: absolute;
width: 15px;
height: 15px;
top: -8px;
right: -8px;
border-width: 3px;
border-style: solid;
-webkit-box-sizing: border-box;
box-sizing: border-box;
z-index: 2;
-webkit-box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
}
.af-view .skills-c .shape__EatFN {
-webkit-box-sizing: border-box;
box-sizing: border-box;
opacity: 0.2;
width: 100%;
height: 190px;
position: absolute;
left: 0;
bottom: 0;
overflow: hidden;
}
.af-view .skills-c .curve__fdcsg {
width: 100%;
position: relative;
background: transparent;
}
.af-view .skills-c .line__EoBr7 {
fill: none;
}
.af-view .skills-c .xAxis__LMHy1 {
width: 100%;
height: 100%;
position: relative;
top: -1px;
-ms-flex-wrap: wrap;
flex-wrap: wrap;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
border-top: 1px solid #cecece;
}
.af-view .skills-c .xAxis__LMHy1::before {
left: -20px;
width: 20px;
}
.af-view .skills-c .xAxis__LMHy1::before, .af-view .xAxis__LMHy1::after {
content: ' ';
height: 1px;
background-color: rgba(255, 255, 255, 0.3);
position: absolute;
top: -1px;
}
.af-view .skills-c .levels__BRSQn {
width: 100%;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
-webkit-box-orient: horizontal;
-webkit-box-direction: normal;
-ms-flex-direction: row;
flex-direction: row;
}
.af-view .level__QZ3Q9 {
-webkit-box-flex: 1;
-ms-flex-positive: 1;
flex-grow: 1;
-ms-flex-preferred-size: 0;
flex-basis: 0;
font-size: 14px;
font-weight: 400;
text-align: center;
line-height: 18px;
position: relative;
}
.af-view .active__DIwr9 {
color: white;
}
.af-view .range__DIpW_ {
font-size: 12px;
font-weight: 400;
color: rgba(255, 255, 255, 0.7);
color: var(--ps-colors-text-icon-low-on-dark);
margin: 0;
}
.af-view .graphFooter__q7_RH {
-webkit-box-flex: 1;
-ms-flex: 1 auto;
flex: 1 auto;
padding: 16px 0;
padding: 5px 0;
width: 100%;
}
.af-view .skills-c .k dl{
color: #6d717f;
}
.af-view /* .w {
height: 100%;
} */
 `,
                                        }}
                                      />
                                      <div className="skills-c">
                                        <div className="a">
                                          <div aria-hidden="true" className="b">
                                            <div className="c">300</div>
                                            <div className="d"></div>
                                            <div className="f">
                                              <p>Skill Points</p>
                                            </div>
                                            <div className="g">0</div>
                                          </div>
                                          <div
                                            aria-hidden="true"
                                            className="h i"
                                          >
                                            <div
                                              aria-hidden="true"
                                              className="j"
                                            >
                                              <div className="k">
                                                <dl className="l m n">
                                                  <dt></dt>
                                                  Beginner
                                                </dl>
                                                <dl className="o m">
                                                  <dt></dt>
                                                  Novice
                                                </dl>
                                                <dl className="p m">
                                                  <dt></dt>
                                                  Intermediate
                                                </dl>
                                                <dl className="q m">
                                                  <dt></dt>
                                                  Advanced
                                                </dl>
                                                <dl className="r m">
                                                  <dt></dt>
                                                  Expert
                                                </dl>
                                              </div>
                                            </div>
                                            <div className="s">
                                              <div className="t">
                                                <div className="u v w"></div>
                                                <div className="x v"></div>
                                                <div className="y v"></div>
                                                <div className="z v"></div>
                                                <div className="expert__EK4nC v"></div>
                                              </div>
                                              <p
                                                className="percentileScore__eqaA3"
                                                style={{
                                                  left: '41.4px',
                                                  bottom: '43.935px',
                                                }}
                                              >
                                                12th percentile
                                              </p>
                                              <div className="scoreBase__Z1ipd">
                                                <p className="score__IvWkK">
                                                  81
                                                </p>
                                                <div>
                                                  <span
                                                    className="gravatarUrl__AzQ29"
                                                    style={{
                                                      borderColor: '#d52ace',
                                                    }}
                                                  ></span>
                                                </div>
                                                <div className="shape__EatFN">
                                                  <div></div>
                                                  <div></div>
                                                  <div></div>
                                                  <div></div>
                                                </div>
                                              </div>
                                              <img
                                                alt=""
                                                className="sv_img"
                                                src="https://uploads-ssl.webflow.com/62b1d984a1c1ca31804d1115/6310e18af762364ab27fd938_62f689efea0370abfc62c141_ex4.png"
                                              />
                                            </div>
                                            <div className="xAxis__LMHy1">
                                              <div className="levels__BRSQn">
                                                <dl className="level__QZ3Q9">
                                                  <dd className="range__DIpW_ active__DIwr9">
                                                    basic knowledge
                                                  </dd>
                                                </dl>
                                                <dl className="level__QZ3Q9">
                                                  <dd className="range__DIpW_">
                                                    limited experience
                                                  </dd>
                                                </dl>
                                                <dl className="level__QZ3Q9">
                                                  <dd className="range__DIpW_">
                                                    practical application
                                                  </dd>
                                                </dl>
                                                <dl className="level__QZ3Q9">
                                                  <dd className="range__DIpW_">
                                                    applied theory
                                                  </dd>
                                                </dl>
                                                <dl className="level__QZ3Q9">
                                                  <dd className="range__DIpW_">
                                                    recognized authority
                                                  </dd>
                                                </dl>
                                              </div>
                                              <div className="axisLabel__ac6OU">
                                                Global Learner Percentile
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-48 home db">
                              <div className="pr_g f lf ma home mgr0">
                                <div className="div-block-14">
                                  <div className="skm">Monthly Activity</div>
                                </div>
                                <div>
                                  <div className="div-block-20">
                                    <div className="div-block-21">
                                      <img
                                        alt=""
                                        className="image-17"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 12px, 1vw"
                                        src="images/trophy.png"
                                        srcset="images/trophy-p-500.png 500w, images/trophy.png 512w"
                                      />
                                    </div>
                                    <div className="text-block-14">
                                      Skills Points
                                    </div>
                                    <div className="text-block-15">546</div>
                                  </div>
                                  <div className="div-block-20">
                                    <div className="div-block-21">
                                      <img
                                        alt=""
                                        className="image-17"
                                        loading="lazy"
                                        src="images/time_1time.png"
                                        width={12}
                                      />
                                    </div>
                                    <div className="text-block-14">
                                      Time Spent
                                    </div>
                                    <div className="text-block-15">
                                      12 Hours
                                    </div>
                                  </div>
                                  <div className="div-block-20">
                                    <div className="div-block-21">
                                      <img
                                        alt=""
                                        className="image-17"
                                        loading="lazy"
                                        src="images/play-button_1play-button.png"
                                      />
                                    </div>
                                    <div className="text-block-14">
                                      Watched Videos
                                    </div>
                                    <div className="text-block-15">15</div>
                                  </div>
                                  <div className="div-block-20">
                                    <div className="div-block-21">
                                      <img
                                        alt=""
                                        className="image-17"
                                        loading="lazy"
                                        src="images/checklist_1checklist.png"
                                      />
                                    </div>
                                    <div className="text-block-14">
                                      Assessments
                                    </div>
                                    <div className="text-block-15">8</div>
                                  </div>
                                  <div className="div-block-20">
                                    <div className="div-block-21">
                                      <img
                                        alt=""
                                        className="image-17"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 12px, 1vw"
                                        src="images/check_2.png"
                                        srcset="images/check_2-p-500.png 500w, images/check_2.png 512w"
                                      />
                                    </div>
                                    <div className="text-block-14">
                                      Course Completions
                                    </div>
                                    <div className="text-block-15">5</div>
                                  </div>
                                </div>
                                <div className="div-block-374">
                                  <a
                                    className="link-block-4 w-inline-block"
                                    href="https://ibl-skills-v7.webflow.io/profile"
                                  >
                                    <div className="text-block-217">
                                      All Activity
                                    </div>
                                    <img
                                      alt=""
                                      className="image-125 rc"
                                      loading="lazy"
                                      src="images/chevron_1chevron.png"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="pr_g f inp home sp">
                                <div className="div-block-14">
                                  <div className="skm">
                                    Skill Points
                                    <br />
                                  </div>
                                </div>
                                <div className="graphs-row">
                                  <div className="html-embed-2 skill-point dblock w-embed w-script">
                                    <style
                                      dangerouslySetInnerHTML={{
                                        __html: `
 .af-view #MeSeStatusCanvas325ba{
  margin-left:auto;
 	margin-right:auto;
    height:196px !important;
 }
 `,
                                      }}
                                    />
                                    <canvas
                                      id="MeSeStatusCanvas325ba"
                                      style={{ width: '95%', height: 150 }}
                                    ></canvas>
                                    <div
                                      style={{
                                        textAlign: 'center',
                                        marginTop: 10,
                                      }}
                                    >
                                      Points
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="text-block-13 more an">
                              <a
                                className="link-6 more"
                                href="https://ibl-skills-v7.webflow.io/profile"
                              >
                                More
                              </a>
                            </div>
                            <div className="text-block-10 mg_b_20">
                              Pathways
                            </div>
                            <div className="pathway_res sl_c">
                              <div className="results flex home_path">
                                <a
                                  className="link-block-7 w-inline-block"
                                  href="#"
                                  id="w-node-_284f4780-0a3e-f214-7af0-5e77de0180e9-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_284f4780-0a3e-f214-7af0-5e77de0180ea-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                        srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                      />
                                      <div className="label">
                                        <div className="text-block-124">
                                          PATHWAY
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            sizes="(max-width: 991px) 100vw, (max-width: 1279px) 28px, (max-width: 1439px) 2vw, (max-width: 1919px) 28px, 1vw"
                                            src="images/google.png"
                                            srcset="images/google-p-500.png 500w, images/google.png 512w"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Google
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            130 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 p">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            2+ Months
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 mob w-inline-block"
                                  href="book.html"
                                  id="w-node-_284f4780-0a3e-f214-7af0-5e77de018120-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_284f4780-0a3e-f214-7af0-5e77de018121-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                        srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                      />
                                      <div className="label">
                                        <div className="text-block-124">
                                          PATHWAY
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/ibm.png"
                                          />
                                        </div>
                                        <div className="text-block-16">IBM</div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            120 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Advanced
                                          <strong className="bold-text-2 p">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            2+ Months
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 tb w-inline-block"
                                  href="article.html"
                                  id="w-node-_284f4780-0a3e-f214-7af0-5e77de018157-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_284f4780-0a3e-f214-7af0-5e77de018158-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        src="images/60fe91c1fcf26f99f44d8b6c_3.jpeg"
                                      />
                                      <div className="label">
                                        <div className="text-block-124">
                                          PATHWAY
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/Stanford_Coursera_Logo.png"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Stanford University
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            10 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Advanced
                                          <strong className="bold-text-2 p">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            2+ Months
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <div
                                  className="slider tablet w-slider"
                                  data-animation="slide"
                                  data-autoplay="false"
                                  data-autoplay-limit={0}
                                  data-delay={4000}
                                  data-disable-swipe="false"
                                  data-duration={500}
                                  data-easing="ease"
                                  data-hide-arrows="false"
                                  data-infinite="true"
                                  data-nav-spacing={3}
                                >
                                  <div className="mask w-slider-mask">
                                    <div className="slide w-slide">
                                      <div className="div-block-42">
                                        <a
                                          className="link-block-7 w-inline-block"
                                          href="#"
                                        >
                                          <div
                                            className="item-box"
                                            id="w-node-_284f4780-0a3e-f214-7af0-5e77de018193-c66baae3"
                                          >
                                            <div className="div-block-22">
                                              <img
                                                alt=""
                                                className="image-11"
                                                loading="lazy"
                                                sizes="100vw"
                                                src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                                srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                              />
                                              <div className="label">
                                                <div className="text-block-124">
                                                  PATHWAY
                                                </div>
                                              </div>
                                            </div>
                                            <div className="item-body">
                                              <div className="div-block-23">
                                                <div className="div-block-24">
                                                  <img
                                                    alt=""
                                                    className="image-18"
                                                    loading="lazy"
                                                    sizes="100vw"
                                                    src="images/google.png"
                                                    srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                  />
                                                </div>
                                                <div className="text-block-16">
                                                  Google
                                                </div>
                                                <div className="div-block-28">
                                                  <div className="text-block-20">
                                                    130 Skill Coins
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="text-block-9">
                                                Python for Data Science, AI
                                                &amp; Development
                                              </div>
                                              <div className="div-block-25">
                                                <div className="text-block-17">
                                                  <span className="skill_span">
                                                    Computer Programming
                                                  </span>{' '}
                                                  <span className="skill_span">
                                                    Python Libraries
                                                  </span>
                                                  <span className="skill_span last">
                                                    Python Programming
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="div-block-26">
                                                <img
                                                  alt=""
                                                  className="image-19"
                                                  loading="lazy"
                                                  sizes="100vw"
                                                  src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                  srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                                />
                                                <div className="text-block-18">
                                                  (1k+)
                                                </div>
                                              </div>
                                              <div className="div-block-27">
                                                <div className="text-block-19">
                                                  Beginner
                                                  <strong className="bold-text-2 p">
                                                    {' '}
                                                  </strong>
                                                  <span className="bullet">
                                                    <strong className="bold-text-2">
                                                      •
                                                    </strong>
                                                  </span>
                                                  <strong className="bold-text-2">
                                                    {' '}
                                                    2+ Months
                                                  </strong>
                                                </div>
                                                <div className="item_options">
                                                  <div className="item_options_triger">
                                                    <img
                                                      alt=""
                                                      className="image-20"
                                                      loading="lazy"
                                                      src="images/menu_1menu.png"
                                                    />
                                                  </div>
                                                  <div className="options_div">
                                                    <div className="text-block-103">
                                                      Add to Pathway
                                                    </div>
                                                    <div className="text-block-103">
                                                      Save for Later
                                                    </div>
                                                    <div className="text-block-103">
                                                      Dismiss
                                                    </div>
                                                    <div className="text-block-103">
                                                      Share
                                                    </div>
                                                    <div className="text-block-103">
                                                      Create a Pathway
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                    <div className="slide w-slide">
                                      <div className="div-block-42">
                                        <a
                                          className="link-block-7 w-inline-block"
                                          href="#"
                                        >
                                          <div
                                            className="item-box"
                                            id="w-node-_284f4780-0a3e-f214-7af0-5e77de0181cc-c66baae3"
                                          >
                                            <div className="div-block-22">
                                              <img
                                                alt=""
                                                className="image-11"
                                                loading="lazy"
                                                sizes="100vw"
                                                src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                                srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                              />
                                              <div className="label">
                                                <div className="text-block-124">
                                                  PATHWAY
                                                </div>
                                              </div>
                                            </div>
                                            <div className="item-body">
                                              <div className="div-block-23">
                                                <div className="div-block-24">
                                                  <img
                                                    alt=""
                                                    className="image-18"
                                                    loading="lazy"
                                                    sizes="100vw"
                                                    src="images/google.png"
                                                    srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                  />
                                                </div>
                                                <div className="text-block-16">
                                                  Google
                                                </div>
                                                <div className="div-block-28">
                                                  <div className="text-block-20">
                                                    130 Skill Coins
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="text-block-9">
                                                Python for Data Science, AI
                                                &amp; Development
                                              </div>
                                              <div className="div-block-25">
                                                <div className="text-block-17">
                                                  <span className="skill_span">
                                                    Computer Programming
                                                  </span>{' '}
                                                  <span className="skill_span">
                                                    Python Libraries
                                                  </span>
                                                  <span className="skill_span last">
                                                    Python Programming
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="div-block-26">
                                                <img
                                                  alt=""
                                                  className="image-19"
                                                  loading="lazy"
                                                  sizes="100vw"
                                                  src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                  srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                                />
                                                <div className="text-block-18">
                                                  (1k+)
                                                </div>
                                              </div>
                                              <div className="div-block-27">
                                                <div className="text-block-19">
                                                  Beginner
                                                  <strong className="bold-text-2 p">
                                                    {' '}
                                                  </strong>
                                                  <span className="bullet">
                                                    <strong className="bold-text-2">
                                                      •
                                                    </strong>
                                                  </span>
                                                  <strong className="bold-text-2">
                                                    {' '}
                                                    2+ Months
                                                  </strong>
                                                </div>
                                                <div className="item_options">
                                                  <div className="item_options_triger">
                                                    <img
                                                      alt=""
                                                      className="image-20"
                                                      loading="lazy"
                                                      src="images/menu_1menu.png"
                                                    />
                                                  </div>
                                                  <div className="options_div">
                                                    <div className="text-block-103">
                                                      Add to Pathway
                                                    </div>
                                                    <div className="text-block-103">
                                                      Save for Later
                                                    </div>
                                                    <div className="text-block-103">
                                                      Dismiss
                                                    </div>
                                                    <div className="text-block-103">
                                                      Share
                                                    </div>
                                                    <div className="text-block-103">
                                                      Create a Pathway
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="left-arrow w-slider-arrow-left">
                                    <img
                                      alt=""
                                      className="image-25"
                                      loading="lazy"
                                      src="images/next-3_1next-3.png"
                                    />
                                  </div>
                                  <div className="right-arrow w-slider-arrow-right">
                                    <img
                                      alt=""
                                      className="image-26"
                                      loading="lazy"
                                      src="images/next-1_1next-1.png"
                                    />
                                  </div>
                                  <div className="slide-nav w-slider-nav w-round"></div>
                                </div>
                              </div>
                              <div
                                className="slider tablet home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="true"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_1802e8e1-0e64-c1b4-74f2-02539ebe0c4d-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_1802e8e1-0e64-c1b4-74f2-02539ebe0c4e-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-_1802e8e1-0e64-c1b4-74f2-02539ebe0c84-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_1802e8e1-0e64-c1b4-74f2-02539ebe0c85-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-a1fedf0d-21a6-ecd9-6803-4d3b379679fe-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-a1fedf0d-21a6-ecd9-6803-4d3b379679ff-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-a1fedf0d-21a6-ecd9-6803-4d3b37967a35-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-a1fedf0d-21a6-ecd9-6803-4d3b37967a36-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                              <div
                                className="slider mobile home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="false"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_3ef09af8-332b-7eee-3e4f-4d185e3575c6-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_3ef09af8-332b-7eee-3e4f-4d185e3575c7-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 16px, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="book.html"
                                        id="w-node-_3ef09af8-332b-7eee-3e4f-4d185e35766d-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_3ef09af8-332b-7eee-3e4f-4d185e35766e-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="book.html"
                                        id="w-node-_1b8ff62a-dad5-4946-b7ba-62ef2b8d3540-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_1b8ff62a-dad5-4946-b7ba-62ef2b8d3541-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow home w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow home w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                            </div>
                            <div className="text-block-13 more">
                              <a
                                className="link-6 more"
                                href="https://ibl-skills-v7.webflow.io/profile#p"
                              >
                                More
                              </a>
                            </div>
                            <div className="text-block-10 mg_b_20">Courses</div>
                            <div className="courses_res sl_c">
                              <div className="results flex home_path">
                                <a
                                  className="link-block-7 w-inline-block"
                                  href="#"
                                  id="w-node-b1639951-3f1a-233f-4ae1-b774073c105f-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-b1639951-3f1a-233f-4ae1-b774073c1060-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/c8.jpg"
                                        srcset="images/c8-p-500.jpeg 500w, images/c8-p-1080.jpeg 1080w, images/c8-p-1600.jpeg 1600w, images/c8-p-2000.jpeg 2000w, images/c8-p-2600.jpeg 2600w, images/c8-p-3200.jpeg 3200w, images/c8.jpg 4288w"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            sizes="(max-width: 991px) 100vw, (max-width: 1279px) 28px, (max-width: 1439px) 2vw, (max-width: 1919px) 28px, 1vw"
                                            src="images/google.png"
                                            srcset="images/google-p-500.png 500w, images/google.png 512w"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Google
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            130 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 mob w-inline-block"
                                  href="book.html"
                                  id="w-node-b1639951-3f1a-233f-4ae1-b774073c1095-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-b1639951-3f1a-233f-4ae1-b774073c1096-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/x.jpg"
                                        srcset="images/x-p-500.jpg 500w, images/x-p-800.jpg 800w, images/x-p-1080.jpg 1080w, images/x.jpg 1280w"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/ibm.png"
                                          />
                                        </div>
                                        <div className="text-block-16">IBM</div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            120 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 tb w-inline-block"
                                  href="article.html"
                                  id="w-node-b1639951-3f1a-233f-4ae1-b774073c10cb-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-b1639951-3f1a-233f-4ae1-b774073c10cc-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/b2.jpeg"
                                        srcset="images/b2-p-500.jpeg 500w, images/b2-p-800.jpeg 800w, images/b2.jpeg 1000w"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/Stanford_Coursera_Logo.png"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Stanford University
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            10 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div
                                className="slider tablet home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="true"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f3ac-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f3ad-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f3e3-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f3e4-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f41c-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f41d-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f453-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_5b6b31cf-96b1-54f8-a480-7fa430d3f454-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                              <div
                                className="slider mobile home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="false"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-d74820ba-19cf-0b49-84fb-a945a01be827-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-d74820ba-19cf-0b49-84fb-a945a01be828-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/c8.jpg"
                                              srcset="images/c8-p-500.jpeg 500w, images/c8-p-1080.jpeg 1080w, images/c8-p-1600.jpeg 1600w, images/c8-p-2000.jpeg 2000w, images/c8-p-2600.jpeg 2600w, images/c8-p-3200.jpeg 3200w, images/c8.jpg 4288w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 16px, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_9a2c00fc-4ac1-0ad6-5249-9f5b3dd82ffd-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_9a2c00fc-4ac1-0ad6-5249-9f5b3dd82ffe-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 16px, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_553200ce-124e-19ec-af0c-36757289fe27-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_553200ce-124e-19ec-af0c-36757289fe28-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 16px, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow home w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow home w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                            </div>
                            <div className="text-block-13 more">
                              <a
                                className="link-6 more"
                                href="https://ibl-skills-v7.webflow.io/profile#cs"
                              >
                                More
                              </a>
                            </div>
                            <div className="text-block-10 mg_b_20">
                              Community Content
                            </div>
                            <div className="shared_res sl_c">
                              <div className="results flex home_path">
                                <a
                                  className="link-block-7 w-inline-block"
                                  href="#"
                                  id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468ea6f-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468ea70-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        src="images/c21.jpg"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            sizes="(max-width: 991px) 100vw, (max-width: 1279px) 28px, (max-width: 1439px) 2vw, (max-width: 1919px) 28px, 1vw"
                                            src="images/google.png"
                                            srcset="images/google-p-500.png 500w, images/google.png 512w"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Google
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            130 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 mob w-inline-block"
                                  href="book.html"
                                  id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468eaa5-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468eaa6-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        sizes="(max-width: 991px) 100vw, (max-width: 1279px) 22vw, 234px"
                                        src="images/geometric-gbcbf05bfd_640.jpg"
                                        srcset="images/geometric-gbcbf05bfd_640-p-500.jpeg 500w, images/geometric-gbcbf05bfd_640.jpg 640w"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/ibm.png"
                                          />
                                        </div>
                                        <div className="text-block-16">IBM</div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            120 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a
                                  className="link-block-7 tb w-inline-block"
                                  href="article.html"
                                  id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468eadb-c66baae3"
                                >
                                  <div
                                    className="item-box"
                                    id="w-node-_32c89d70-9c98-4238-10f6-a7fa3468eadc-c66baae3"
                                  >
                                    <div className="div-block-22">
                                      <img
                                        alt=""
                                        className="image-11"
                                        loading="lazy"
                                        src="images/7-p-500.jpeg"
                                      />
                                      <div className="label c">
                                        <div className="text-block-124">
                                          COURSE
                                        </div>
                                      </div>
                                    </div>
                                    <div className="item-body">
                                      <div className="div-block-23">
                                        <div className="div-block-24">
                                          <img
                                            alt=""
                                            className="image-18"
                                            loading="lazy"
                                            src="images/Stanford_Coursera_Logo.png"
                                          />
                                        </div>
                                        <div className="text-block-16">
                                          Stanford University
                                        </div>
                                        <div className="div-block-28">
                                          <div className="text-block-20">
                                            10 Skill Coins
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-block-9">
                                        Python for Data Science, AI &amp;
                                        Development
                                      </div>
                                      <div className="div-block-25">
                                        <div className="text-block-17">
                                          <span className="skill_span">
                                            Computer Programming
                                          </span>{' '}
                                          <span className="skill_span">
                                            Python Libraries
                                          </span>
                                          <span className="skill_span last">
                                            Python Programming
                                          </span>
                                        </div>
                                      </div>
                                      <div className="div-block-26">
                                        <img
                                          alt=""
                                          className="image-19"
                                          loading="lazy"
                                          sizes="(max-width: 991px) 100vw, (max-width: 1279px) 80.0078125px, (max-width: 1439px) 6vw, 80.0078125px"
                                          src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                          srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                        />
                                        <div className="text-block-18">
                                          (1k+)
                                        </div>
                                      </div>
                                      <div className="div-block-27">
                                        <div className="text-block-19">
                                          Beginner
                                          <strong className="bold-text-2 c">
                                            {' '}
                                          </strong>
                                          <span className="bullet">
                                            <strong className="bold-text-2">
                                              •
                                            </strong>
                                          </span>
                                          <strong className="bold-text-2">
                                            {' '}
                                            20 Hours
                                          </strong>
                                        </div>
                                        <div className="item_options">
                                          <div className="item_options_triger">
                                            <img
                                              alt=""
                                              className="image-20"
                                              loading="lazy"
                                              src="images/menu_1menu.png"
                                            />
                                          </div>
                                          <div className="options_div">
                                            <div className="text-block-103">
                                              Add to Pathway
                                            </div>
                                            <div className="text-block-103">
                                              Save for Later
                                            </div>
                                            <div className="text-block-103">
                                              Dismiss
                                            </div>
                                            <div className="text-block-103">
                                              Share
                                            </div>
                                            <div className="text-block-103">
                                              Create a Pathway
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div
                                className="slider tablet home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="true"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_7c3649d9-0477-c381-482e-800dda3db928-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_7c3649d9-0477-c381-482e-800dda3db929-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              src="images/c21.jpg"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-_7c3649d9-0477-c381-482e-800dda3db95f-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_7c3649d9-0477-c381-482e-800dda3db960-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_7c3649d9-0477-c381-482e-800dda3db998-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_7c3649d9-0477-c381-482e-800dda3db999-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                              srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-7 mob w-inline-block"
                                        href="book.html"
                                        id="w-node-_7c3649d9-0477-c381-482e-800dda3db9cf-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_7c3649d9-0477-c381-482e-800dda3db9d0-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 16px, (max-width: 991px) 2vw, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                              <div
                                className="slider mobile home w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="false"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="mask w-slider-mask">
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="#"
                                        id="w-node-_32344792-c509-c2d5-49f7-3696027bdeae-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_32344792-c509-c2d5-49f7-3696027bdeaf-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              src="images/c21.jpg"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 16px, 100vw"
                                                  src="images/google.png"
                                                  srcset="images/google-p-500.png 500w, images/google.png 512w"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                Google
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  130 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Beginner
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="book.html"
                                        id="w-node-_32344792-c509-c2d5-49f7-3696027bdee7-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_32344792-c509-c2d5-49f7-3696027bdee8-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label c">
                                              <div className="text-block-124">
                                                COURSE
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="slide w-slide">
                                    <div className="results flex slider">
                                      <a
                                        className="link-block-7 w-inline-block"
                                        href="book.html"
                                        id="w-node-_32344792-c509-c2d5-49f7-3696027bdf20-c66baae3"
                                      >
                                        <div
                                          className="item-box"
                                          id="w-node-_32344792-c509-c2d5-49f7-3696027bdf21-c66baae3"
                                        >
                                          <div className="div-block-22">
                                            <img
                                              alt=""
                                              className="image-11"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 16px, 100vw"
                                              src="images/6123cb8af7e1077407c91720_course3.jpeg"
                                              srcset="images/6123cb8af7e1077407c91720_course3-p-500.jpeg 500w, images/6123cb8af7e1077407c91720_course3.jpeg 640w"
                                            />
                                            <div className="label">
                                              <div className="text-block-124">
                                                PATHWAY
                                              </div>
                                            </div>
                                          </div>
                                          <div className="item-body">
                                            <div className="div-block-23">
                                              <div className="div-block-24">
                                                <img
                                                  alt=""
                                                  className="image-18"
                                                  loading="lazy"
                                                  src="images/ibm.png"
                                                />
                                              </div>
                                              <div className="text-block-16">
                                                IBM
                                              </div>
                                              <div className="div-block-28">
                                                <div className="text-block-20">
                                                  120 Skill Coins
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-block-9">
                                              Python for Data Science, AI &amp;
                                              Development
                                            </div>
                                            <div className="div-block-25">
                                              <div className="text-block-17">
                                                <span className="skill_span">
                                                  Computer Programming
                                                </span>{' '}
                                                <span className="skill_span">
                                                  Python Libraries
                                                </span>
                                                <span className="skill_span last">
                                                  Python Programming
                                                </span>
                                              </div>
                                            </div>
                                            <div className="div-block-26">
                                              <img
                                                alt=""
                                                className="image-19"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 16px, 100vw"
                                                src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                                srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                              />
                                              <div className="text-block-18">
                                                (1k+)
                                              </div>
                                            </div>
                                            <div className="div-block-27">
                                              <div className="text-block-19">
                                                Advanced
                                                <strong className="bold-text-2 p">
                                                  {' '}
                                                </strong>
                                                <span className="bullet">
                                                  <strong className="bold-text-2">
                                                    •
                                                  </strong>
                                                </span>
                                                <strong className="bold-text-2">
                                                  {' '}
                                                  2+ Months
                                                </strong>
                                              </div>
                                              <div className="item_options">
                                                <div className="item_options_triger">
                                                  <img
                                                    alt=""
                                                    className="image-20"
                                                    loading="lazy"
                                                    src="images/menu_1menu.png"
                                                  />
                                                </div>
                                                <div className="options_div">
                                                  <div className="text-block-103">
                                                    Add to Pathway
                                                  </div>
                                                  <div className="text-block-103">
                                                    Save for Later
                                                  </div>
                                                  <div className="text-block-103">
                                                    Dismiss
                                                  </div>
                                                  <div className="text-block-103">
                                                    Share
                                                  </div>
                                                  <div className="text-block-103">
                                                    Create a Pathway
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow home w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-25"
                                    loading="lazy"
                                    src="images/next-3_1next-3.png"
                                  />
                                </div>
                                <div className="right-arrow home w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-26"
                                    loading="lazy"
                                    src="images/next-1_1next-1.png"
                                  />
                                </div>
                                <div className="slide-nav w-slider-nav w-round"></div>
                              </div>
                            </div>
                            <div className="text-block-13 more">
                              <a
                                className="link-6 more"
                                href="https://ibl-skills-v7.webflow.io/social#sh"
                              >
                                More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="social_div">
                      <div className="social_cont">
                        <div
                          className="social_box followers"
                          data-name="followers"
                        >
                          <div className="div-block-147">
                            <div>Followers</div>
                            <img
                              alt=""
                              className="image-72"
                              loading="lazy"
                              src="images/close_2close.png"
                            />
                          </div>
                          <div className="div-block-148">
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/t6.jpg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Sara Joyner</div>
                                  <div className="text-block-94">
                                    Manual Testing Engineer
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Eathan Adam</div>
                                  <div className="text-block-94">
                                    Mining Engineer
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Maira Paul</div>
                                  <div className="text-block-94">
                                    Technical Support Representative
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Nimra Jefferson</div>
                                  <div className="text-block-94">
                                    Software Quality Assurance
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Kealan Walters</div>
                                  <div className="text-block-94">
                                    Computer Science Professor
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  sizes="100vw"
                                  src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                  srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Isobella Simmonds</div>
                                  <div className="text-block-94">
                                    Product Manager
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Remove</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="social_box following"
                          data-name="followers"
                        >
                          <div className="div-block-147">
                            <div>Following</div>
                            <img
                              alt=""
                              className="image-72 following"
                              loading="lazy"
                              src="images/close_2close.png"
                            />
                          </div>
                          <div className="div-block-148">
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  sizes="100vw"
                                  src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                  srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Isobella Simmonds</div>
                                  <div className="text-block-94">
                                    Product Manager
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Nimra Jefferson</div>
                                  <div className="text-block-94">
                                    Software Quality Assurance
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Eathan Adam</div>
                                  <div className="text-block-94">
                                    Mining Engineer
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Maira Paul</div>
                                  <div className="text-block-94">
                                    Technical Support Representative
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/t6.jpg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Sara Joyner</div>
                                  <div className="text-block-94">
                                    Manual Testing Engineer
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                            <div className="div-block-149">
                              <a
                                className="link-block-6 w-inline-block"
                                href="https://ibl-skills.webflow.io/public-profile"
                              >
                                <img
                                  alt=""
                                  className="image-73"
                                  loading="lazy"
                                  src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                />
                                <div className="div-block-150">
                                  <div className="bname">Kealan Walters</div>
                                  <div className="text-block-94">
                                    Computer Science Professor
                                  </div>
                                </div>
                              </a>
                              <div className="div-block-151">
                                <div className="text-block-95">Following</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default HomeCopyView;

/* eslint-enable */
